import { render, staticRenderFns } from "./RemoveMember.vue?vue&type=template&id=8234b454&scoped=true&"
import script from "./RemoveMember.vue?vue&type=script&lang=js&"
export * from "./RemoveMember.vue?vue&type=script&lang=js&"
import style0 from "./RemoveMember.vue?vue&type=style&index=0&id=8234b454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8234b454",
  null
  
)

component.options.__file = "RemoveMember.vue"
export default component.exports